// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"3672419d","171":"172a6b6d"}[chunkId] + ".chunk.js";
};